import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { POPUP_NAMES, PRODUCT_DATA } from '../utils/constants';
export const PurchasePopup: React.FC = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const showPopup = () => {
      const randomName = POPUP_NAMES[Math.floor(Math.random() * POPUP_NAMES.length)];
      toast.custom(t => <div className="bg-white rounded-xl shadow-xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm animate-in slide-in-from-bottom-5" data-id="element-234">
            <img src={PRODUCT_DATA.mainImage} alt="Product" className="w-12 h-12 object-cover rounded-lg bg-gray-50" data-id="element-235" />
            <div data-id="element-236">
              <p className="text-sm font-bold text-gray-900" data-id="element-237">{randomName}</p>
              <p className="text-xs text-green-600 font-medium" data-id="element-238">
                Ha comprado este producto
              </p>
              <p className="text-xs text-gray-400 mt-1" data-id="element-239">Hace unos minutos</p>
            </div>
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      // Schedule next popup between 15 and 30 seconds
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutRef.current = setTimeout(showPopup, nextDelay);
    };
    // Initial popup after 10 seconds
    timeoutRef.current = setTimeout(showPopup, 10000);
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return null; // This component only handles logic and triggers toasts
};